module.exports = __webpack_public_path__ + "img/participant-select-mobile-en.de73ba1b.jpg";